"use strict";

exports.__esModule = true;
exports.isStatelessComponent = void 0;
const isStatelessComponent = Component => !(Component.prototype && Component.prototype.render);
exports.isStatelessComponent = isStatelessComponent;
//# sourceMappingURL=isStatelessComponent.js.map